var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.186,
    height: 26.725,
    viewBox: "0 0 23.186 26.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-alt",
    "data-name": "Icon awesome-calendar-alt",
    d: "M0,24.22a2.5,2.5,0,0,0,2.484,2.505H20.7a2.5,2.5,0,0,0,2.484-2.505v-14.2H0ZM16.561,13.989a.626.626,0,0,1,.621-.626h2.07a.626.626,0,0,1,.621.626v2.088a.626.626,0,0,1-.621.626h-2.07a.626.626,0,0,1-.621-.626Zm0,6.681a.626.626,0,0,1,.621-.626h2.07a.626.626,0,0,1,.621.626v2.088a.626.626,0,0,1-.621.626h-2.07a.626.626,0,0,1-.621-.626ZM9.937,13.989a.626.626,0,0,1,.621-.626h2.07a.626.626,0,0,1,.621.626v2.088a.626.626,0,0,1-.621.626h-2.07a.626.626,0,0,1-.621-.626Zm0,6.681a.626.626,0,0,1,.621-.626h2.07a.626.626,0,0,1,.621.626v2.088a.626.626,0,0,1-.621.626h-2.07a.626.626,0,0,1-.621-.626ZM3.312,13.989a.626.626,0,0,1,.621-.626H6a.626.626,0,0,1,.621.626v2.088A.626.626,0,0,1,6,16.7H3.933a.626.626,0,0,1-.621-.626Zm0,6.681a.626.626,0,0,1,.621-.626H6a.626.626,0,0,1,.621.626v2.088A.626.626,0,0,1,6,23.384H3.933a.626.626,0,0,1-.621-.626ZM20.7,3.341H18.217V.835A.834.834,0,0,0,17.389,0H15.733a.834.834,0,0,0-.828.835V3.341H8.281V.835A.834.834,0,0,0,7.453,0H5.8a.834.834,0,0,0-.828.835V3.341H2.484A2.5,2.5,0,0,0,0,5.846V8.352H23.186V5.846A2.5,2.5,0,0,0,20.7,3.341Z",
    fill: "#235a9f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.ad66153b03fe7c092d3cde09a7e9b568.svg";
export { ForwardRef as ReactComponent };